<template>
  <div class="fareItem__select">
    <label class="fareInformation__container">
      <span class="fareInformation__checkmark"></span>
      <span class="fareInformation__prevPrice" v-if="!displayFullPrices">
        <span class="fareInformation__prevPriceCurrency">
          {{ currency }}
        </span>
        <span class="fareInformation__prevPriceCurrency">
          {{ minimumPrice }}
        </span>
      </span>
      <span class="fareInformation__label">
        <span class="fareItem__calculator" v-if="!displayFullPrices">+</span>
        <span class="fareItem__price">
          {{ amount | amountFormatPipe }}
        </span>
        <span class="fareItem__currency">{{ currency }}</span>
        <!-- <span class="fareItem__selectInfo">{{
          $t('shopping_lib.per_person')
        }}</span> -->
      </span>
    </label>
  </div>
</template>
<script>
import filters from '../../helpers/filters'
export default {
  name: 'FareItemInformation',
  mixins: [filters],
  inject: ['configurations'],
  props: {
    minimumPrice: {
      type: Number,
    },
    currency: {
      type: String,
    },
    amount: {
      type: Number,
    },
    displayFullPrices: {
      type: Boolean,
    },
  },
}
</script>

<style lang="sass" scoped></style>
